import { AgxSpacer, AgxToggleSwitch, AgxTypography } from '@urbanx/agx.ui-components2';
import { TaskStepDto } from '@urbanx/agx.activities.client';
import { TaskModalPageProps } from './TaskModalPageProps';

interface TaskModalStepToggleProps extends Pick<TaskModalPageProps, 'toggleTaskStep'> {
  step: TaskStepDto;
  displayName?: string;
  onChange?: (isChecked: boolean) => void;
  large?: boolean;
}

const TaskModalStepToggle = ({
  step,
  displayName,
  onChange,
  toggleTaskStep,
  large = false,
}: TaskModalStepToggleProps) => {
  return (
    <AgxSpacer
      direction="horizontal"
      gap={large ? 'spacing-xl' : 'spacing-lg'}
      contentJustification="space-between"
      contentAlignment="start"
      fill
    >
      <AgxSpacer direction="vertical" padding={{ top: large ? 'spacing-sm' : 'spacing-xs' }}>
        <AgxTypography
          id={`step-${step.name}`}
          type={'body_ui'}
          size={'medium'}
          color="var(--text-primary)"
        >
          {displayName ?? step.name}
        </AgxTypography>
      </AgxSpacer>
      <AgxToggleSwitch
        id={`step-${step.name}`}
        checked={step.isCompleted ?? false}
        onChange={onChange ?? ((isChecked) => toggleTaskStep(step.order ?? 0, isChecked))}
      />
    </AgxSpacer>
  );
};

export default TaskModalStepToggle;
